import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const DefaultText = ({ listDefaultBlock }) => {
    return (
        <FullWrapper className="default-text">
            <div className="default-textWrapper">
                <div
                    dangerouslySetInnerHTML={{ __html: listDefaultBlock.title }}
                    className="default-textTitle"
                />
                <div
                    dangerouslySetInnerHTML={{ __html: listDefaultBlock.textTop }}
                    className="default-textTop"
                />
                {/*<div className="default-textDetail">*/}
                {/*    <div*/}
                {/*        dangerouslySetInnerHTML={{ __html: listDefaultBlock.description }}*/}
                {/*        className="default-textDescription"*/}
                {/*    />*/}
                {/*    <div className="default-textItem">*/}
                {/*        <img*/}
                {/*            src={listDefaultBlock.img}*/}
                {/*            alt={listDefaultBlock.name}*/}
                {/*            className="default-textItemImage"*/}
                {/*        />*/}
                {/*        <div className="default-textItemInner">*/}
                {/*            <div className="default-textItemName">{listDefaultBlock.name}</div>*/}
                {/*            <div className="default-textItemPosition">*/}
                {/*                {listDefaultBlock.position}*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div
                    dangerouslySetInnerHTML={{ __html: listDefaultBlock.textBottom }}
                    className="default-textBottom"
                />
            </div>
        </FullWrapper>
    );
};

export default DefaultText;
